/**
 * The whole tree: providers and the app. The browser renders it (main.tsx) and the build renders it to HTML for every
 * public page (prerender/entry-server.tsx, ADR-0061) — one tree, so the HTML and the hydrating render are the same.
 */
import { type QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LazyMotion } from "framer-motion";
import { StrictMode } from "react";
import { LangProvider } from "../i18n";
import { App } from "./App";
import { LocaleRouter } from "./LocaleRouter";

// The light `m` components render at once; the animation features arrive in their own chunk (ADR-0048).
const motionFeatures = () => import("../lib/motionFeatures").then((r) => r.default);

/** `ssrPath`: the URL being prerendered (/ru/faq); the browser reads its own location. Its language is the page's. */
export function Root({ client, ssrPath }: { client: QueryClient; ssrPath?: string }) {
  return (
    <StrictMode>
      <QueryClientProvider client={client}>
        <LangProvider ssrPath={ssrPath}>
          <LazyMotion features={motionFeatures}>
            <LocaleRouter ssrPath={ssrPath}>
              <App />
            </LocaleRouter>
          </LazyMotion>
        </LangProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}
